<template>
  <div class="eligibilities-list-data component">
    <v-progress-linear
      :indeterminate="!progress"
      :value="progress"
      height="5"
      class="ma-0"
      v-show="loading && loadingIndicator"
    />
    <slot v-bind="{ eligibilities, loading }" v-if="eligibilities"></slot>
    <slot name="no-data" v-show="!loading">
      <v-card tile class="text-xs-center" v-if="eligibilities.length === 0 && !hasIncomplete">
        <v-card-text>
          <v-alert outline type="info" color="info" :value="!loading">
            <span class="subheading" v-if="isFiltered">
              All candidates in this phase have been filtered out.
            </span>
            <span class="subheading" v-else>
              There are no candidates in this phase.
            </span>
          </v-alert>
        </v-card-text>
      </v-card>
    </slot>
    <slot name="footer" v-show="!loading">
      <v-card tile class="text-xs-center" v-if="hasIncomplete">
        <v-card-text>
          <v-alert outline type="info" color="info" :value="hideIncomplete">
            <span class="subheading">
              Incomplete profiles are hidden.
            </span>
            <v-btn color="secondary" @click="hideIncomplete = false">
              Show me
            </v-btn>
          </v-alert>
          <v-alert outline type="info" color="info" :value="!hideIncomplete">
            <span class="subheading">
              You can hide incomplete profiles.
            </span>
            <v-btn color="secondary" @click="hideIncomplete = true">
              Hide
            </v-btn>
          </v-alert>
        </v-card-text>
      </v-card>
    </slot>
    <slot name="paginate" v-bind="{ total, pages, page, per, from, to, paginate }">
      <div class="text-xs-center mt-3">
        <v-pagination :value="Number(page)" :length="pages" @input="paginate({ page: $event })" />
        <div class="caption">
          <span> Showing {{ from }}-{{ to }} of {{ total }} </span>
          <span>
            <v-menu offset-y>
              <v-btn slot="activator" flat small class="caption">
                {{ per }} per Page
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
              <v-list dark>
                <v-list-tile
                  v-for="value in [25, 100, 500]"
                  :key="value"
                  @click="paginate({ rowsPerPage: value })"
                >
                  <v-list-tile-title>{{ value }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    filters: { type: Object },
    loading: { type: Boolean, default: false },
    loadingIndicator: { type: Boolean, default: true },
  },

  created() {
    this.$store.dispatch('admin/eligibilities/updateFilters', { ...this.filters, ...this.params })
  },

  data() {
    return {
      params: {},
      hideIncomplete: true,
    }
  },

  computed: {
    ...mapState('admin/eligibilities', {
      active: 'active',
      total: 'total',
      page: 'page',
      per: 'rowsPerPage',
      storeFilters: 'filters',
    }),

    ...mapState('admin/opportunities', {
      counts: 'counts',
    }),

    progress() {
      return this.$store.getters['admin/eligibilities/progress']
    },

    hasIncomplete() {
      return this.$store.getters['admin/eligibilities/hasIncomplete']
    },

    eligibilities() {
      if (this.hideIncomplete) {
        return this.active.filter(eligibility => eligibility.complete)
      }
      return this.active
    },

    pages() {
      return Math.ceil(this.total / this.per)
    },

    from() {
      return this.total > 0 ? 1 + (this.page - 1) * this.per : 0
    },

    to() {
      return Math.min(this.per * this.page, this.total)
    },

    isFiltered() {
      const irrelevantFilters = ['status']

      return Object.keys(this.storeFilters).filter(f => irrelevantFilters.indexOf(f) < 0).length > 0
    },
  },

  watch: {
    filters: {
      handler: function(value) {
        this.$store.dispatch('admin/eligibilities/updateFilters', { ...value })
      },
      deep: true,
    },
  },

  methods: {
    paginate(change) {
      if (change) {
        Object.assign(this.params, change)
        this.$store.dispatch('admin/eligibilities/updateFilters', { ...change })
      }
    },

    async fetch() {
      this.$store.commit('admin/eligibilities/clearSelected')
      await this.$store.dispatch('admin/eligibilities/load', { opportunity: Vue.$route.params.id })
      // Pass filters from the URL to the store
      this.$store.dispatch('admin/eligibilities/updateFilters', { ...this.filters, ...this.params })
    },
  },
}
</script>
